import {Controller as GroupController} from './../../../zviz2/zviz/components/group';
import Rectangle from './../../../zviz2/zviz/components/rectangle';
import {Controller as ArcController} from './../../../zviz2/zviz/components/arc';

import {extend} from './../../../zviz2/zviz/functions';

class Controller extends ArcController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);
        this.scale = 0;
    }

    render(renderer){
        super.render(renderer);
        
        this.scale += renderer.delta / 1000;
        if(this.scale > 1){
            this.scale -= 1;
        }

        this.update();
    }
}



let Blueprint = {
    type: GroupController,
    properties: {
        data: {
            width: 500,
            height: 200,
            size: 50,
            color: '#555555',
            background: 'rgba(255,255,255,0.5)'
        }
    },

    children: [
        extend({
            properties: {
                attributes: {
                    'x': 0,
                    'y': 0,
                    'width': (ctrl) => ( ctrl.parent.data.width ),
                    'height': (ctrl) => ( ctrl.parent.data.height )
                },
                style: {
                    fill: (ctrl) => ( ctrl.parent.data.background )
                }
            }
        }, Rectangle),
        {
            type: Controller,
            properties:{
                style: {
                    'fill': (ctrl) => ( ctrl.parent.data.color ),
                    'fillOpacity': (ctrl) => ( (1 - ctrl.scale) ),
                    'strokeWidth': '0px'
                },
                attributes: {
                    'r': (ctrl) => ( (ctrl.scale * ctrl.parent.data.size) ),
                    'cx': (ctrl) => ( 0.5 * ctrl.parent.data.width ),
                    'cy': (ctrl) => ( 0.35 * ctrl.parent.data.height ),
                }
            }
        }
    ]
}


export default Blueprint;
export {Controller};
